import React from 'react';
import styled from "styled-components";
import CardTwo from "../../components/cards/CardTwo";
import { MdOutlineCampaign } from "react-icons/md";
import { MdDesignServices } from "react-icons/md";
import { FiRefreshCw } from "react-icons/fi";
import { RiLightbulbFlashLine } from "react-icons/ri";
import { FaRegStar } from "react-icons/fa";
import { BsFillHouseCheckFill } from "react-icons/bs";

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #041c40;
  text-align: center;
  font: normal normal bold 60px / 53px ;
`;

const Divider = styled.div`
  width: 100px;
  height: 3px;
  background-color: #f7bc0c;
  margin: 0 auto 30px;
`;


const items = [
  {
    title: "Quality",
    description:
      "We are committed to consistently delivering products and services of the highest quality, exceeding our customers' expectations.",
    image: <BsFillHouseCheckFill />,
  },
  {
    title: "Innovation",
    description:
      "We continuously seek new ideas and technologies to stay at the forefront of design and functionality.",
    image: <RiLightbulbFlashLine />,
  },
  {
    title: "Safety",
    description:
      "We ensure that every product and service provides comfort and protection for our customers and their families.",
    image: <MdOutlineCampaign />,
  },
  {
    title: "Design",
    description:
      "We prioritize design in every project, combining functionality and aesthetics to create unique and attractive spaces.",
    image: <MdDesignServices />,
  },
  {
    title: "Originality",
    description:
      "We celebrate originality as a cornerstone of our work, offering solutions that reflect each client's personality and style.",
    image: <FaRegStar />,
  },
  {
    title: "Renewal",
    description:
      "We believe in constant renewal as the key to staying relevant and ensuring our products and services are always at the forefront.",
    image: <FiRefreshCw />,
  },
];

const Values = () => {
  return (
    <div className="col-md-12">
          <div className="display-flex justify-content-center">
            <div className="col-12 display-flex justify-content-center">
              <Title>Values</Title>
            <Divider />
              <div className="row">
                <div
                  className="col-lg-12 col-md-12 col-sm-12 col-12 p-5 fs-3 text-start"
                  style={{
                    alignSelf: "center",
                    display: "flex",
                    "flex-wrap": "wrap",
                  }}
                >
                  {items.map(({ title, description, image }, i) => {
                    return (
                      <div className="col-lg-4 col-md-4 col-sm-6 col-12 p-3">
                        <CardTwo
                          title={title}
                          description={description}
                          image={image}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
  )
}

export default Values;